package org.chiangmeng.qfast.core.presentation

import org.chiangmeng.qfast.core.domain.models.QueueTicket
import org.chiangmeng.qfast.core.domain.models.Shop

data class QueueUiState(
    val shop: Shop? = null,
    val activeQueues: List<QueueTicket> = emptyList(),
    val isLoading: Boolean = true,
    val errorMessage: String? = null
)
